import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { BehaviorSubject, Observable } from "rxjs";

@Injectable()
export class UrlService {
  private previousUrl: BehaviorSubject<any[]> = new BehaviorSubject<any[]>(
    null
  );
  public previousUrl$: Observable<any[]> = this.previousUrl.asObservable();
  captureUrlHistory: any;

  constructor(private _router: Router) {}
  previousUrl1: any;
  previousUrlArray = [
    {
      url: "",
      urlName: "",
      type: "",
    },
  ];
  capturedUrl: any;

  setPreviousUrl(previousUrl: string, urlName?: string, type?: string) {
    //  for (let i = 0; i < this.previousUrlArray.length; i++) {
    //   if(type==this.previousUrlArray[i].type){
    //      delete this.previousUrlArray[i];
    //   }
    //  }
    let isDuplicateExist = false;
    this.previousUrlArray.forEach((element) => {
      if (element.type == type) {
        isDuplicateExist = true;
        (element["url"] = previousUrl),
          (element["urlName"] = urlName),
          (element["type"] = type);
      }
    });
    if (!isDuplicateExist) {
      this.previousUrlArray.push({
        url: previousUrl,
        urlName: urlName,
        type: type,
      });
    }
    let list = [];
    switch (type) {
      case "testModule":
        
        list = [];

        break;
      case "testSuite":

        list = this.previousUrlArray.filter((f) => f.type == "testSuite");

        break;
      case "testCase":
        list = this.previousUrlArray.filter(
          (f) => f.type == "testSuite" || f.type == "testCase"
        );
        break;
      case "testStep":
        list = this.previousUrlArray.filter(
          (f) =>
            f.type == "testSuite" ||
            f.type == "testCase" ||
            f.type == "testStep"
        );
        break;
      default:
    }
    this.previousUrl.next(list);
  }
  resetUrl() {
    this.previousUrlArray = [];
  }
  captureUrl(currentUrl, urlName?: string, type?: string) {
    this.capturedUrl = currentUrl;
    if (
      currentUrl.includes("/test") ||
      (currentUrl.includes("/project") &&
        !currentUrl.includes("/test/run-management"))
    ) {
      this.setPreviousUrl(currentUrl, urlName, type);
    }
    this.previousUrl$.subscribe((previousUrl) => {
      this.previousUrl1 = previousUrl;
    });
    return this.removeDuplicates(this.previousUrl1);
  }
  removeUrlSyntax(arr) {
    let count = 0;
    for (let index = 0; index < arr.length; index++) {
      if (arr[index]["url"].includes("test/TestStep")) {
        count++;
        if (count > 1) {
          console.log("arr1", arr);

          console.log(arr[index]);
        }
      }
    }
  }

  removeDuplicates(arr) {
    console.log("arra", arr);

    const uniqueArray = arr.filter((thing, index) => {
      const _thing = JSON.stringify(thing);
      return (
        index ===
        arr.findIndex((obj) => {
          return JSON.stringify(obj) === _thing;
        })
      );
    });
    console.log(uniqueArray);

    return uniqueArray;
  }

  geturlName(url) {
    if (url.includes("/setting/project-setting")) {
      return "project-setting";
    } else if (url.includes("/test/TestStep/")) {
      return "Test-step";
    } else if (url.includes("/test/TestSuit")) {
      return "TestCase";
    } else if (url.includes("/data/manage-test-data")) {
      return "Manage-test-data";
    } else if (url.includes("/project/suite")) {
      return "Test-Suite";
    } else if (url.includes("/project/module")) {
      return "Test-Module";
    }
  }
}
